export enum EnvType {
    dev = "DEV",
    uat = "UAT",
    pro = "PRO"
}

export const AppConfig = {
    envType: EnvType.dev,
    requestTimeout: 60000,
    buildDate: "2023-04-03 15:30",
}

export const isDebug = (AppConfig.envType !== EnvType.pro)
